import { render, staticRenderFns } from "./aboutall.vue?vue&type=template&id=3a26c758&"
import script from "./aboutall.vue?vue&type=script&lang=js&"
export * from "./aboutall.vue?vue&type=script&lang=js&"
import style0 from "./aboutall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports